import { Box, Card, Stack, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { useAppSelector } from "Hooks/useRedux";
import { useDispatch } from "react-redux";
import { changePage } from "Redux/pageSlice";

export default function CarouselButtons() {
  const { page } = useAppSelector((state) => state.page);

  const dispatch = useDispatch();

  const handlePage = (event: React.MouseEvent<HTMLElement>, newMode: any) => {
    if (newMode !== null) {
      dispatch(changePage(Number(newMode)));
    }
  };

  return (
    <>
      <Card sx={{ width: "32vw" }}>
        <ToggleButtonGroup value={page} onChange={handlePage} exclusive aria-label="survay-show-type" sx={{ width: "32vw" }}>
          <ToggleButton
            value={1}
            aria-label="reports"
            style={{
              width: "7.5vw",
              height: "56px",
              backgroundColor: page === 1 ? "#4754CA" : "",
              color: page === 1 ? "#fff" : "",
              marginRight: "0px",
            }}
          >
            گزارشات
          </ToggleButton>
          <ToggleButton
            value={2}
            aria-label="supports"
            style={{
              width: "8.5vw",
              height: "56px",
              backgroundColor: page === 2 ? "#4754CA" : "",
              color: page === 2 ? "#fff" : "",
              marginRight: "0px",
            }}
          >
            پشتیبانی
          </ToggleButton>
          <ToggleButton
            value={3}
            aria-label="its"
            style={{
              width: "8.5vw",
              height: "56px",
              backgroundColor: page === 3 ? "#4754CA" : "",
              color: page === 3 ? "#fff" : "",
              marginRight: "0px",
            }}
          >
            تحلیل ترافیکی
          </ToggleButton>
          <ToggleButton
            value={4}
            aria-label="its"
            style={{
              width: "7.5vw",
              height: "56px",
              backgroundColor: page === 4 ? "#4754CA" : "",
              color: page === 4 ? "#fff" : "",
              marginRight: "0px",
            }}
          >
            حمل و نقل
          </ToggleButton>
        </ToggleButtonGroup>
      </Card>
    </>
  );
}
